import React, {useState} from 'react';


const modes = [
  {
    value: 'automatic',
    label: 'Automatisch',
    description: 'Übergangsregel, Probezeitraum und Payment-Status entscheiden.',
  },
  {
    value: 'force_allowed',
    label: 'Zugang erzwingen',
    description: 'Die Wachabteilung bleibt unabhängig vom Payment-Status aktiv.',
  },
  {
    value: 'force_blocked',
    label: 'Sperre erzwingen',
    description: 'Employee- und Admin-Zugang werden manuell gesperrt.',
  },
];


const PaymentAccessOverrideControl = ({department, onChange}) => {
  const [saving, setSaving] = useState(false);
  const currentMode = department.payment_access_override || 'automatic';

  const handleModeChange = async mode => {
    if (saving || mode === currentMode) return;
    const selected = modes.find(item => item.value === mode);
    const confirmed = window.confirm(
      `Zahlungszugang für "${department.department_name}" auf ` +
      `„${selected.label}“ setzen?`
    );
    if (!confirmed) return;

    setSaving(true);
    try {
      await onChange(mode);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="border-b pb-6">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h4 className="text-md font-semibold text-gray-800">🔐 Zahlungszugang</h4>
          <p className="mt-1 text-sm text-gray-600">
            Automatische Zahlungssperre oder manueller Developer-Eingriff.
          </p>
        </div>
        <span className={`rounded px-2 py-1 text-xs font-semibold ${
          department.payment_access_blocked
            ? 'bg-red-100 text-red-800'
            : 'bg-green-100 text-green-800'
        }`}>
          {department.payment_access_blocked
            ? 'Aktuell gesperrt'
            : 'Aktuell freigegeben'}
        </span>
      </div>

      <div className="space-y-2">
        {modes.map(mode => (
          <label
            key={mode.value}
            className="flex cursor-pointer items-start gap-3 rounded-lg bg-gray-50 p-3"
          >
            <input
              type="radio"
              name={`payment-access-${department.department_id}`}
              value={mode.value}
              checked={currentMode === mode.value}
              disabled={saving}
              onChange={() => handleModeChange(mode.value)}
              className="mt-1 h-4 w-4 text-blue-600"
            />
            <span>
              <span className="block font-medium text-gray-800">{mode.label}</span>
              <span className="block text-sm text-gray-500">{mode.description}</span>
            </span>
          </label>
        ))}
      </div>
      {saving && <p className="mt-2 text-sm text-blue-700">Änderung wird gespeichert …</p>}
    </div>
  );
};


export default PaymentAccessOverrideControl;
